<template>
    <div class="footer">
        <div class="con">
            <div class="con-left">
                <div class="small-title">
                    <span>
                        <img src="http://music.chinaman.cn/mybigdatas/icm2030/new0616/logo.png" alt="">
                    </span> ICM 2030 Hong Kong
                </div>
                <div class="word-text">
                    Join the <span>world's mathematicians</span> in Hong Kong
                </div>
                <div class="right">

                    <div class="right-text">Follow us:</div>
                    <div class="follow-img-lists">
                        <span>
                            <a href="https://youtube.com/@hkicm2030_bid?si=s-_teO6_6nXVeHP6" target="_blank">
                                <img src="http://music.chinaman.cn/mybigdatas/icm2030/b5.png" alt="">
                            </a>
                        </span>
                        <span>
                            <a href="https://x.com/HKICM2030bid" target="_blank">
                                <img src="http://music.chinaman.cn/mybigdatas/icm2030/b6.png" alt="">
                            </a>
                        </span>
                        <span>
                            <a href="https://www.instagram.com/hk_icm_2030bid?igsh=cmZxbGpkMm8wN3J6&utm_source=qr"
                                target="_blank">
                                <img src="http://music.chinaman.cn/mybigdatas/icm2030/b2.png" alt="">
                            </a>
                        </span>
                        <span>
                            <a href="https://www.linkedin.com/company/115224169/admin/page-posts/published/"
                                target="_blank">
                                <img src="http://music.chinaman.cn/mybigdatas/icm2030/b3.png" alt="">
                            </a>
                        </span>
                        <span>
                            <a href="https://www.facebook.com/HKICM2030bid/" target="_blank">
                                <img src="http://music.chinaman.cn/mybigdatas/icm2030/b1.png" alt="">
                            </a>
                        </span>
                        <!-- <span>
                            <a href="https://www.reddit.com/user/Outrageous_Day4422/" target="_blank">
                                <img src="http://music.chinaman.cn/mybigdatas/icm2030/b4.png" alt="">
                            </a>
                        </span>
                        <span>
                            <a href="https://www.tiktok.com/@hk_icm2030bid" target="_blank">
                                <img src="http://music.chinaman.cn/mybigdatas/icm2030/b7.png" alt="">
                            </a>
                        </span> -->
                    </div>
                </div>
                <div class="bottom"> © 2026 Hong Kong Mathematical Society. All Rights Reserved.
                </div>
            </div>

            <div class="left-lists">
                <div class="list">
                    <p v-for="(item, i) in routerList" :class="i % 2 == 0 ? 'left-text' : 'text1'" :key="i"
                        @click="toPageFn(item.path)">
                        {{ item.name }}
                    </p>
                </div>
            </div>
        </div>
    </div>

</template>
<script>
export default {
    data() {
        return {
            routerList: [
                {
                    name: 'Home',
                    path: '/'
                },
                {
                    name: 'Congress',
                    path: '/gaIcm'
                },
                {
                    name: 'Organisers',
                    path: '/organizers'
                },
                {
                    name: 'Support',
                    path: '/comprehensiveSupport'
                },
                {
                    name: 'Hong Kong',
                    path: '/why'
                },
                // {
                //     name: 'Resource',
                //     path: '/resource'
                // },
            ],
            footerList: [{
                name: 'Main Endorsing institutes:',
                list: [
                    {
                        img: 'http://music.chinaman.cn/mybigdatas/icm2030/f6.png',
                        name: 'Chinese Mathematical Society'
                    },
                    {
                        img: 'http://music.chinaman.cn/mybigdatas/icm2030/f7.png',
                        name: 'Society for Industrial and Applied Mathematics'
                    },
                    {
                        img: 'http://music.chinaman.cn/mybigdatas/icm2030/f9.png',
                        name: 'Indian Statistical Institute'
                    },
                    {
                        img: 'http://music.chinaman.cn/mybigdatas/icm2030/f4.png',
                        name: 'Macau Mathematical Society'
                    },
                    {
                        img: 'http://music.chinaman.cn/mybigdatas/icm2030/f8.png',
                        name: 'Hong Kong Society of Applied Mathematics for Industry'
                    },
                    {
                        img: 'http://music.chinaman.cn/mybigdatas/icm2030/f5.png',
                        name: 'Hong Kong Mathematical and Physical Education Association'
                    },
                    {
                        img: 'http://music.chinaman.cn/mybigdatas/icm2030/f10.png',
                        name: 'Hong Kong Innovation, Technology and Industry Bureau'
                    },
                ]
            }],
        }
    },
    methods: {
        toPageFn(path) {
            this.$router.push(path)
        }
    }
}
</script>

<style lang="less" scoped>
.footer {
    padding: 20px 0 40px;
    background: #002EA2;
    color: #fff;


    .small-title {
        color: #fff !important;
        font-size: 36px;
        font-weight: 700;
        display: flex;
        align-items: center;
        position: relative;

        &::before {
            content: '';
            left: 600px;
            top: 30%;
            height: 200px;
            background-color: #0065FF;
            width: 2px;
            position: absolute;
        }

        &::after {
            content: none;
        }

        span,
        img {
            width: 48px;
            height: 48px;
            margin-right: 10px;
            display: inline-block;
        }
    }

    .word-text {
        font-size: 24px;
        line-height: 130px;
        color: #fff;
        font-weight: 500;
        margin-top: -50px;

        span {
            color: #FFEEC8;
        }
    }


    .word-text {
        font-size: 22px;
        line-height: 1.8;
        font-weight: 300;
        margin-top: 20px;
        margin-bottom: 40px;
    }

    .left-lists {
        width: 430px;
        box-sizing: border-box;
        padding-top: 50px;
        position: relative;

        .list {
            cursor: pointer;
            font-size: 18px;
            line-height: 1.5;
            display: flex;
            flex-wrap: wrap;

            p {
                width: calc(50% - 20px);
                box-sizing: border-box;
                margin-bottom: 14px;
            }

            .left-text {
                margin-right: 40px;
            }
        }
    }

    .con-left {
        flex: 1;
    }

    .right {
        box-sizing: border-box;
        position: relative;
        margin-bottom: 70px;

        &::before {
            content: '';
            left: -20%;
            top: 0;
            height: 80%;
            background-color: rgba(255, 255, 255, .4);
            width: 1px;
            position: absolute;

        }


        .follow-img-lists {
            display: flex;
            justify-content: flex-start;
            flex-wrap: wrap;
            gap: 5px;

            span {
                width: 35px;
                height: 35px;
                margin-right: 10px;
                background: #DBAE00;
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;

                img {
                    width: auto;
                    height: 16px;
                }
            }
        }

        .right-text {
            font-size: 20px;
            margin-bottom: 14px;
        }


        .right-text-2 {
            margin-top: 30px;
        }


    }


    .con {
        max-width: 1200px;
        margin: 0 auto 20px;
        padding: 0 20px;
        display: flex;
        justify-content: space-between;
        position: relative;
    }

}

@media screen and (max-width: 768px) {
    .footer {
        padding: 30px 15px;

        .con {
            flex-direction: column;
        }

        .small-title {
            font-size: 24px;

            span {
                width: 36px;
                height: 36px;
            }
        }

        .word-text {
            font-size: 16px;
            margin-top: 15px;
            margin-bottom: 25px;
        }

        .con-left {
            &::before {
                display: none;
            }
        }

        .right {
            &::before {
                display: none;
            }

            margin-bottom: 30px;

            .right-text {
                font-size: 16px;
                margin-bottom: 12px;
            }

            .follow-img-lists {
                gap: 0;

                span {
                    width: 30px;
                    height: 30px;

                    img {
                        height: 14px;
                    }
                }
            }
        }

        .left-lists {
            width: 100%;
            padding-top: 20px;
            border-top: 1px solid rgba(255, 255, 255, 0.2);

            .list {
                font-size: 15px;

                p {
                    width: calc(50% - 10px);
                    margin-bottom: 12px;
                }

                .left-text {
                    margin-right: 20px;
                }
            }
        }

        .bottom {
            font-size: 14px;
            position: absolute;
            bottom: -30px;
        }
    }
}

@media screen and (max-width: 480px) {
    .footer {
        padding: 25px 10px 30px;

        .small-title {
            font-size: 20px;

            span {
                width: 30px;
                height: 30px;
                margin-right: 8px;
            }

            img {
                width: 30px;
                height: 30px;
            }
        }

        .word-text {
            font-size: 14px;
            margin-top: 12px;
            margin-bottom: 20px;
        }

        .right {
            margin-bottom: 25px;

            .right-text {
                font-size: 14px;
            }

            .follow-img-lists {
                span {
                    width: 28px;
                    height: 28px;

                    img {
                        height: 12px;
                    }
                }
            }
        }

        .left-lists {
            .list {
                font-size: 14px;

                p {
                    margin-bottom: 10px;
                }
            }
        }

        .bottom {
            bottom: -40px;
            font-size: var(--font-size-a);
            left: 0;
            text-align: center;
            width: 100%;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/footer.vue